<div class="check-avail-title-text" style="background-color: #ededed;">
  <span class="order-text">{{'common.check_availability_btn_text'|cxTranslate}}</span>

  <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
    <img src="/icons/close-light-grey.svg" alt="" width="25" />
  </button>
</div>
<mat-dialog-content>
  @if (!showNextPage) {
  <div class="row checkAvail-form-section">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 ">
      <div class="form-group">
        <label class="control-label" for="Order Type"> {{'common.text_quickOrder_order_type'|cxTranslate}}</label>
        <div class="control select">
          @if (activeCart$|async; as cart) {
          <div class="select-box">
            <select class="form-control outline" (change)="resetQty()" [(ngModel)]="selectedOrderType">
              @for (item of $any(cart)?.orderType?.entry; track item) {
              <option [value]="item.key">{{item.value}}</option>
              }
            </select>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 ">
      <div class="form-group">
        <label class="control-label" for="Quantity">{{'common.text_quantity'|cxTranslate}}</label>
        @if (selectedOrderType!=='EMGY') {
        <input class="form-control hidden mileage-input" (keydown)="onKeyDown($event)" type="text"
          [(ngModel)]="enteredQty" value="">
        }
        @if (selectedOrderType==='EMGY') {
        <div class="select-box" id="vorOrderQtyWpr">
          <select class="form-control outline" [(ngModel)]="selectedQunatity">
            <option value="1" selected="selected">1</option>
            <option value="2">2</option>
          </select>
        </div>
        }
      </div>
      @if (selectedOrderType!=='EMGY' && enteredQty=='' && isSubmitted) {
      <p class="error">{{'common.please_enter_quantity_text'|cxTranslate}}</p>
      }
    </div>

    @if (isLoading()) {
    <kb-loader />
    } @else {

    @if (showMsg) {
    @if (selectedOrderType==='EMGY' && stockRes && stockRes[0]?.availableForEmergency==false) {
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center avail-status">
      <p class="status-text">{{_data?.productCode}} {{'common.check_out_of_stock_text'|cxTranslate}}
        {{stockRes[0]?.cutOffOrderTypeMessage}}</p>
    </div>
    }
    @if (selectedOrderType==='EMGY' && stockRes && stockRes[0]?.availableForEmergency==true) {
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center avail-status">
      <p class="status-text">{{_data?.productCode}} {{'common.available_product_text'|cxTranslate}}
        {{stockRes[0]?.cutOffOrderTypeMessage}}</p>
    </div>
    }
    }
    }
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
      <button type="button" id="checkAvailBtn" (click)="checkAvail()"
        class="btn btn-primary check-avail-btn col-xs-12 col-sm-12 col-md-6 col-lg-6 col-md-offset-3 col-lg-offset-3">{{'common.check_availability_btn_text'|cxTranslate}}</button>
    </div>
  </div>
  }

  @if (showNextPage) {
  <div class="row checkAvail-table-section">
    <h2 class="check-avail-title"><span class="chk-product-code">{{_data?.productCode}}&nbsp;</span>
      @if (selectedOrderType!=='EMGY') {
      @if (stockRes && isAvailable) {
      <span class="text-availibiliy">{{'common.check_available_table_text'|cxTranslate}}</span>
      }
      @if (stockRes && isPartialAvailable) {
      <span class="text-availibiliy">{{'common.check_part_available_table_text'|cxTranslate}}</span>
      }
      @if ((stockRes && stockRes.length==0) ||(!isAvailable && !isPartialAvailable)) {
      <span class="text-availibiliy">{{'common.check_not_available_table_text'|cxTranslate}}</span>
      }
      }
      @if (selectedOrderType==='EMGY') {
      @if (stockRes && stockRes[0].availableForEmergency) {
      <span class="text-availibiliy">{{'common.check_available_table_text'|cxTranslate}}</span>
      }
      @if (stockRes && !stockRes[0].availableForEmergency) {
      <span class="text-availibiliy">{{'common.check_not_available_table_text'|cxTranslate}}</span>
      }
      }
    </h2>
    <table class="table table-striped checkAvail-table">
      <thead>
        <tr>
          <th scope="col">{{'common.text_quantity'|cxTranslate}}</th>
          <th scope="col">{{'common.product_product_details_future_date'|cxTranslate}}</th>
        </tr>
      </thead>
      <tbody>
        @for (item of stockRes; track item) {
        <tr>
          <td>{{item.stock.stockLevel}}</td>
          <td>{{item.formattedDate}}</td>
        </tr>
        }
      </tbody>
    </table>
    <div class="d-flex align-items-center justify-content-between back-btn-container">
      <span id="productCutoffTime" class="prod-cutoff-time hidden">@if (stockRes&& stockRes[0].availableForEmergency) {
        <span>{{'common.please_note_text'|cxTranslate}} {{stockRes&& stockRes[0].cutOffOrderTypeMessage}}
          {{'common.must_be_placed_by'|cxTranslate}} {{stockRes&& stockRes[0].cutOffTimeMessage}} {{stockRes&&
          stockRes[0].cutOffZoneMessage}}</span>
        }</span>
      <p class="checkavlBack back-to-savedcart-link" (click)="back()">
        {{'common.text_account_order_back_btn'|cxTranslate}}</p>
    </div>
  </div>
  }
</mat-dialog-content>